import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { FilterId } from '../../filters/types/filters';

const geographyTransitionsItems: TabContent['items'] = [
  {
    position: { x: 0, width: 32, y: 0, height: 36 },
    id: 'geography-transitions-v2-sankey',
    title: 'Transitions',
    info: {
      text: 'The most common sources of incoming workers and destinations of outgoing workers over the full available history by default.',
    },
    plot: {
      defaultMetricOptions: ['transitions_inflows_and_outflows'],
      chartType: 'sankey',
      sankey: {
        widthScale: 'power',
        totalExponent: 0.7,
        shareExponent: 0.7,
      },
    },
  },
  {
    position: { x: 32, width: 16, y: 0, height: 18 },
    id: 'geography-transitions-v2-role',
    title: 'Role',
    info: {
      text: 'Worker inflows and outflows by occupation, as well as the net change, over the full available history by default. More information on the job representation and taxonomy can be found <a>.',
      hyperlinks: [
        {
          text: 'here',
          href: 'https://www.data-dictionary.reveliolabs.com/methodology.html#jobs-taxonomy',
        },
      ],
    },
    plot: {
      secondaryDimension: 'role',
      defaultMetricOptions: ['transitions_inflows_and_outflows'],
      chartType: 'diverging-bar-combo',
      showDataLabels: true,
      hideOther: true,
      divergingBarCombo: {
        comparisonLabel: '',
        differenceLabel: '',
        leftHeaderLabel: '',
        rightHeaderLabel: '',
        sort: { by: 'sum' },
      },
      isSingleEntity: true,
      comparisonTransformation: {
        baseline: 'second',
      },
    },
  },
  {
    position: { x: 32, width: 16, y: 18, height: 18 },
    id: 'geography-transitions-v2-industry',
    title: 'Industry',
    info: {
      text: 'Worker inflows and outflows by industry, as well as the net change, over the full available history by default.',
    },
    plot: {
      secondaryDimension: 'rics',
      defaultMetricOptions: ['transitions_inflows_and_outflows'],
      chartType: 'diverging-bar-combo',
      showDataLabels: true,
      hideOther: true,
      divergingBarCombo: {
        comparisonLabel: '',
        differenceLabel: '',
        leftHeaderLabel: '',
        rightHeaderLabel: '',
        sort: { by: 'sum' },
      },
      isSingleEntity: true,
      comparisonTransformation: {
        baseline: 'second',
      },
    },
  },
];

const geographyTransitionsTab: TabContent = {
  id: 'geography-transitions-v2',
  items: geographyTransitionsItems,
  primaryFilter: {
    id: FilterId.GEOGRAPHY,
    tagColors: true,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.EDUCATION,
    FilterId.ETHNICITY,
    FilterId.GENDER,
    FilterId.ROLE,
    FilterId.SENIORITY,
    FilterId.CUSTOM_SKILL,
    FilterId.ACTIVITY,
    FilterId.COMPANY,
    FilterId.INDUSTRY,
    FilterId.DATE_RANGE,
    FilterId.KEYWORDS,
    FilterId.TITLE,
    FilterId.CONTINGENT_WORKERS,
  ].map((id) => ({ id })),
};

export const geographyTransitions: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.GEOGRAPHY_TRANSITIONS,
  revelioPageId: RevelioPageId.GEOGRAPHY_TRANSITIONS,
  name: 'Transitions',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'geography-transitions-v2',
      label: 'Transitions',
      tabContent: geographyTransitionsTab,
      isActive: true,
    },
  ],
};
